import { Component, OnInit, ViewChild } from "@angular/core";
import {ViewController, NavParams, ModalController, ToastController} from "ionic-angular";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { UserProvider, User } from "../../../../providers/user/user";
import { AvatarProvider } from "../../../../providers/avatar/avatar";
import {ImageEdit} from "../../new-post/image-edit/image-edit";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'edit-profile',
  templateUrl: 'edit-profile.component.html'
})
export class EditProfileComponent implements OnInit {

  emailRegex = new RegExp('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])');

  user: User;

  // profileForm: FormGroup = this.fb.group({
  //   last_name: [''],
  //   first_name: [''],
  //   description: [''],
  //   contact_email: ['', Validators.email],
  //   gender: [''],
  //   avatar: ['']
  // });

  avatarString: string;

  constructor(
    private toastCtrl: ToastController,
    protected viewCtrl: ViewController,
    protected navParams: NavParams,
    private userProvider: UserProvider,
    private avatarProvider: AvatarProvider,
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.user = this.navParams.get('user') as User;
  }

  ngOnInit(): void {
    this.loadProfileInfos();
  }

  handleFileSelect(evt){
    var files = evt.target.files;
    var file = files[0];

    this.presentModal(file);
  }


  presentModal(file) {
    const modal = this.modalCtrl.create(ImageEdit, {file: file});
    modal.onDidDismiss(res => {
      if(res?.image) {
        this.avatarString = res.image;
      }
    });
    modal.present().then(() => {});
  }

  loadProfileInfos(){
    this.avatarProvider.get(this.user.avatar_id).subscribe(
      (res) => {
        console.log(res);
        try {
          const avatar = this.ab2str(res.data.avatar_content.data)
          this.avatarProvider.avatarContent = avatar;
          this.avatarString = avatar;
        } catch (err) {
          console.log(err);
        }
      }
    );
  }


  dismiss(): void {
    this.viewCtrl.dismiss();
  }

  // Decoding image buffer
  ab2str(arraybuffer) {
    return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
  }

  async submit() {
    if (!this.emailRegex.test(this.user.contact_email)) {
      await this.toastCtrl.create({
        message: this.translate.instant('edit-profile.email-error'),
        duration: 2000
      }).present();
    }
    else {

      this.userProvider.update(this.user.id, {
        last_name: this.user.last_name,
        first_name: this.user.first_name,
        description: this.user.description,
        contact_email: this.user.contact_email,
        avatar: this.avatarString,
        linkedin_link: this.user.linkedin_link,
        position: this.user.position
      }).subscribe(
        (res) => {
          if(res.success){
            this.avatarProvider.avatarContent = this.ab2str(this.avatarString);
            this.avatarString = this.ab2str(this.avatarString);
            this.loadProfileInfos();
            this.dismiss();
          }else{

          }
        },
        err => console.log(err)
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/profile/edit-profile/edit-profile.component.ts